import { useEffect, useState } from "react";

//interfaces
import { ActionFeedback } from "thrive-components";
import { IUseContentPost } from "@/interfaces/activityFeedNotifications";

//helpers
import { useHaltPropagation } from "@/components/hooks/utility/useHaltPropagation";
import { getContentDeletedBannerMessage } from "@/helpers/ActivityFeed";



const UseContentPost = ({activityId, isPopOut, timeStamp, dateStamp, parentList, notificationDetails, isRemovedFromParentList, getOpenOnWebLink, onArchiveContentClick, onPostCommentClick, onLikeClick, content, appDetails, isModeratedContent, needsApproval, meta, onApproveClick} : IUseContentPost) => {
    const [showCommentFunctionality, setShowCommentFunctionality] = useState<boolean>(false);
    const [commentString, setCommentString] = useState<string>("");
    const [showArchiveContent, setShowArchiveContent] = useState<boolean>(false);
    const [isPosting, setIsPosting] = useState<boolean>(false);

    const contentIsRemoved = isRemovedFromParentList || content.isArchived;
    const contentIsPublished = isModeratedContent ? !contentIsRemoved && !needsApproval : !contentIsRemoved;
    const showApprovalPanel = isPopOut ? !showArchiveContent && !contentIsRemoved && isModeratedContent : !contentIsRemoved && isModeratedContent
    const screenClassName = !isPopOut ? "full-screen-styling" : "";
    const archivedClassName = content.isArchived ? "archived-content" : "";

    const deletedBannerMessage = getContentDeletedBannerMessage(needsApproval, isModeratedContent, content?.isArchived, parentList?.title);
    const showFeedbackBanner : boolean = !!notificationDetails;
    const feedbackType = notificationDetails?.isSuccess ? ActionFeedback.SUCCESS : ActionFeedback.ERROR;
    const feedbackMessage = notificationDetails?.message ?? '';
    const activityInfo = {
        className: screenClassName, 
        time: isPopOut ? timeStamp : undefined,
        dateStamp: `${timeStamp} · ${dateStamp}`,
        likes: meta.likeCount,
        comments: meta.commentCount,
        likesEnabled: meta.likesEnabled,
        commentsEnabled: meta.commentsEnabled,
        appImageUrl:appDetails.isMultipleAppOrganisation ? appDetails.iconUrl : "",
        appName:appDetails.isMultipleAppOrganisation ? appDetails.name : ""
    }
    const showMenu = !content.isArchived;
    const handleLikeClick = contentIsPublished ? onLikeClick : undefined;
    const handleReplyClick = contentIsPublished && onPostCommentClick ? ()=> setShowCommentFunctionality(true) : undefined;
    const webLink = contentIsPublished ? getOpenOnWebLink : undefined;
    const handleArchiveClick = !contentIsRemoved ? () => setShowArchiveContent(true) : undefined;
    const handleApproveClick = !contentIsRemoved && needsApproval ? onApproveClick : undefined;
    
    useEffect(() => {
        setIsPosting(false);
    }, [notificationDetails?.message]);

    function onCommentClick() {
        setIsPosting(true);
        onPostCommentClick && onPostCommentClick(activityId, content.id, commentString, appDetails.id);
        setShowCommentFunctionality(false);
        setCommentString("");
    }

    function onArchiveClick() {
        onArchiveContentClick();
        setShowArchiveContent(false);
    }

    function hideArchiveFunctionality(e?: any) {
        useHaltPropagation(e);
        setShowArchiveContent(false);
    }    

    return {screenClassName, archivedClassName, handleLikeClick, handleReplyClick, webLink, handleArchiveClick, handleApproveClick, showMenu, showFeedbackBanner, feedbackType, feedbackMessage, commentString, setCommentString, onCommentClick, showCommentFunctionality, setShowCommentFunctionality, contentIsRemoved, deletedBannerMessage, showApprovalPanel, showArchiveContent, hideArchiveFunctionality, onArchiveClick, activityInfo, isPosting}
};

export default UseContentPost